import { render, staticRenderFns } from "./SubSub.vue?vue&type=template&id=6b7c53a9"
import script from "./SubSub.vue?vue&type=script&lang=js"
export * from "./SubSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports